// A tiny deterministic PRNG — the only way to get a random number anywhere in
// this codebase.
//
// It lives in `src/engine/rules/` rather than `src/engine/ai/` because the *core* needs it
// too: a work order dropping on a capture is a seeded roll inside the reducer,
// and `src/engine/rules/` may not import from `src/engine/ai/`. `src/engine/ai/random.ts` re-exports
// it so there is still exactly one implementation and `streamFor` is still the
// single door.
//
// It has to be *seeded from the game* rather than from Math.random for the
// same reason `src/engine/rules/` forbids unseeded randomness: two clients derive
// state from one log (PLAN §5.5), and an opponent that wandered would break
// replay just as thoroughly as a reducer that did.

export function mulberry(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * A stream for one decision, mixed from the game's seed and how far in it is.
 *
 * The ply count is what makes the opponent's choices differ from turn to turn
 * while staying a pure function of the state — replay the same log and the
 * same rolls come back.
 */
export function streamFor(seed: number, plies: number, salt: number): () => number {
  return mulberry(seed + plies * 2654435761 + salt * 40503);
}
